// extracted by mini-css-extract-plugin
module.exports = {"legalWrap":"Legal_legalWrap__3nsDv","legalHdr":"Legal_legalHdr__3o8lk","sectionHdr":"Legal_sectionHdr__1jqte","subHead":"Legal_subHead__2Glr3"};